// extracted by mini-css-extract-plugin
var _1 = "Ol2kb125";
export { _1 as "alphabet" }
